import Loader, { type LoaderProps } from "./Loader";
export { Loader as default, Loader, LoaderProps };